// Stale, bundled fallback used only when the live lookup fails. The authoritative values come
// from the backend's GA yum catalogue scrape (which cannot scrape os4 itself); live always wins.
export const FALLBACK_LATEST_OS_VERSIONS = {
    os4: "4.8.9",
    os5: "5.4.4",
    os6: "6.0.4"
};
